import React from 'react';
import { Header } from '../../../Components/Layout/Header.jsx'
import { ObavijestiCasino } from '../../../Components/Layout/ObavijestiCasino.jsx'
import { MetaTags } from '../../../Components/Layout/MetaTags.jsx'

export class ObavijestOObradiOsobnihPodataka extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            textHTML: null,
            loading: true
        }
    }

    componentDidMount() {
        casino.repos.casinoDocumentsRepo.get('opcapravila/obavijest_o_obradi_osobnih_podataka_2025.html').then((dataHTML) => {
            this.setState({
                loading: false,
                textHTML: dataHTML
            });
        });
    }

    render() {
        return (
            <>
                <MetaTags title="Obavijest o obradi osobnih podataka | SuperSport Casino | SuperCasino" description="Opće odredbe o zaštiti osobnih podataka." />
                <Header key="header" {...this.state} {...this.props} />

                <div id="page-wrapper" className="white padding-2p-on-mobile border-on-tablet margin-1p-on-tablet">
                    <div className="padding-sides-medium margin-center">
                        <div className="pravila-text-container">
                            {this.state.loading && <p>Učitavam sadržaj...</p>}
                            {!this.state.loading && this.state.textHTML && <div dangerouslySetInnerHTML={{ __html: this.state.textHTML }} />}
                        </div>
                    </div>
                </div>
                <ObavijestiCasino {...this.props} />
            </>
        )
    }
};